import { useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, dateHoverRange, getFullMonthSelected } from "../../../utils/Helper";
import _ from "underscore";

export const useFeaturesTask = ({ projectId, isFeature, dateFilter, setDateFilter }) => {

    const [date, setDate] = useState({ range: [], month: new Date() });
    const [payloadData, setPayloadData] = useState({})
    const [isChange, setIsChange] = useState(false);
    const [summaryData, setSummaryData] = useState({});
    const [detailsPopup, setDetailsPopup] = useState({ visible: false, data: {} });
    const [loader, setLoader] = useState(false);
    const [hideCard, setHideCard] = useState([]);
    const fields = [
        {
            label: "Carried",
            icon: "arrow-left",
            key: "carried",
            color: "orange",
        },
        {
            label: "Backlog",
            icon: "box-archive",
            key: "backlog",
            color: "#6b7280",
        },
        {
            label: "In Progress",
            icon: "hourglass",
            key: "in_progress",
            color: "#3b82f6",
        },
        {
            label: "Done",
            icon: "circle-check",
            key: "done",
            color: "#3da764",
        },
        {
            label: "Forwarded",
            icon: "arrow-right",
            key: "forwarded",
            color: "orange",
        },
    ]

    useEffect(() => {
        if (!_.isEqual(date?.range, dateFilter?.range) || (dateConvert(date?.month) !== dateConvert(dateFilter?.month))) {
            getTaskFeaturesSummary(_.isEmpty(dateFilter) ? date : dateFilter);
            !_.isEmpty(dateFilter) && setDate(dateFilter);
        }
    }, [dateFilter])

    const getTaskFeaturesSummary = async (dateObj) => {
        try {
            let dateRange = {};
            if (dateObj?.month) {
                dateRange = getFullMonthSelected(dateObj?.month);
            } else if (!_.isEmpty(dateObj?.range)) {
                if (dateObj?.range?.[0] && !dateObj?.range?.[1]) {
                    setDate((prev) => ({ ...prev, range: [], month: new Date() }));
                    dateRange = getFullMonthSelected(new Date());
                } else if (dateObj?.range?.[0] && dateObj?.range?.[1]) {
                    dateRange = {
                        from_date: dateHoverRange(dateObj?.range?.[0]),
                        to_date: dateHoverRange(dateObj?.range?.[1])
                    }
                }
            }
            setLoader(true);
            const payload = {
                project_id: projectId,
                from_date: dateConvert(dateRange?.from_date, "iso-string") || "",
                to_date: dateConvert(dateRange?.to_date, "iso-string") || "",
                is_feature: isFeature
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTTASKFEATURESUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.project_task_feature_summary?.[0];
                setSummaryData(data);
                setPayloadData(payload);
                const from = new Date(payload?.from_date)?.getMonth();
                const to = new Date(payload?.to_date)?.getMonth();
                const current = new Date()?.getMonth();
                if (from > current) {
                    setHideCard(["in_progress", "forwarded"])
                } else if (from === to) {
                    if (from < current) {
                        setHideCard(["in_progress"]);
                    } else if (from === current) {
                        setHideCard(["forwarded"]);
                    }
                } else if (to < current) {
                    setHideCard(["in_progress"]);
                } else {
                    setHideCard([]);
                }
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const changeMonth = (delta) => {
        const newDate = new Date(date?.month?.getFullYear(), date?.month?.getMonth() + delta, 1);
        let dateObj = {...date, month: date?.month ? newDate : new Date(), range: []};
        setDate(dateObj);
        setDateFilter(dateObj);
        getTaskFeaturesSummary(dateObj);
    };

    return useMemo(() => ({
        changeMonth, date, setDate, detailsPopup, setDetailsPopup, fields, summaryData, getTaskFeaturesSummary, isChange, setIsChange, payloadData, loader, hideCard
    }), [changeMonth, date, setDate, detailsPopup, setDetailsPopup, fields, summaryData, getTaskFeaturesSummary, isChange, setIsChange, payloadData, loader, hideCard])
}